import DashboardImage1 from '../assets/project_images/Admin Dashboard 1.png'
import DashboardImage2 from '../assets/project_images/Admin Dashboard 2.png'
import DashboardImage3 from '../assets/project_images/Admin Dashboard 3.png'
import DashboardImage4 from '../assets/project_images/Admin Dashboard 4.png'
import RoyzImage1 from '../assets/project_images/Royz Rental 1.png'
import RoyzImage2 from '../assets/project_images/Royz Rental 2.png'
import RoyzImage3 from '../assets/project_images/Royz Rental 3.png'
import RoyzImage4 from '../assets/project_images/Royz Rental 4.png'
import RoyzImage5 from '../assets/project_images/Royz Rental 5.png'
// import RoyzImage6 from '../assets/project_images/Royz Rental 6.png'
import LearnfinityImage1 from '../assets/project_images/Learnfinity 1.jpg'
import LearnfinityImage2 from '../assets/project_images/Learnfinity 2.jpg'
import LearnfinityImage3 from '../assets/project_images/Learnfinity 3.jpg'
import LearnfinityImage4 from '../assets/project_images/Learnfinity 4.jpg'
import TravelAdvisorImage1 from '../assets/project_images/Travel Advisor 1.png'
import RecipeFinderImage1 from '../assets/project_images/Recipe Finder 1.png'
import RecipeFinderImage2 from '../assets/project_images/Recipe Finder 2.png'
import RecipeFinderImage3 from '../assets/project_images/Recipe Finder 3.png'
// import FamilyNoticeImage1 from '../assets/project_images/Family Notice 1.png'
// import FamilyNoticeImage2 from '../assets/project_images/Family Notice 2.png'
// import FamilyNoticeImage3 from '../assets/project_images/Family Notice 3.png'
// import FamilyNoticeImage4 from '../assets/project_images/Family Notice 4.png'
// import FamilyNoticeImage5 from '../assets/project_images/Family Notice 5.png'
import AwdaImage1 from '../assets/project_images/Awda 1.png'
import QuickTeamsImage1 from '../assets/project_images/Quick Teams 1.jpg'
import QuickTeamsImage2 from '../assets/project_images/Quick Teams 2.jpg'
import foodigif1 from '../assets/experience_images/foodii/foodii gif 1.gif'
import foodigif2 from '../assets/experience_images/foodii/foodii gif 2.gif'
// import foodiPhone1 from '../assets/experience_images/foodii/Phone Screenshots - 1.jpg'
// import foodiPhone2 from '../assets/experience_images/foodii/Phone Screenshots - 2.jpg'
// import foodiPhone3 from '../assets/experience_images/foodii/Phone Screenshots - 3.jpg'
// import foodiPhone4 from '../assets/experience_images/foodii/Phone Screenshots - 4.jpg'
// import foodiPhone5 from '../assets/experience_images/foodii/Phone Screenshots - 5.jpg'
// import foodiPhone6 from '../assets/experience_images/foodii/Phone Screenshots - 6.jpg'
import foodiCollage1 from '../assets/experience_images/foodii/phone screenshots collage 1.png'
import foodiCollage2 from '../assets/experience_images/foodii/phone screenshots collage 2.png'
import foodiWebsite1 from '../assets/experience_images/foodii/Website 1.png'
import foodiWebsiteGIF from '../assets/experience_images/foodii/Foodii Website GIF.gif'
import foodiLogo from '../assets/logos/foodii.png'
// import SRMLogo from '../assets/SRMakes Logo.png'
import SRMakesImage1 from '../assets/project_images/SRMakes Apps 1.webp'
import SRMakesImage2 from '../assets/project_images/SRMakes Apps 2.webp'
import SRMakesImage3 from '../assets/project_images/SRMakes Apps 3.webp'
import SRMakesImage4 from '../assets/project_images/SRMakes Apps 4.webp'
import SRMakesImage5 from '../assets/project_images/SRMakes Apps 5.webp'
import SENTuitionImage1 from '../assets/project_images/SEN Tuition 1.png'
import SENTuitionImage2 from '../assets/project_images/SEN Tuition 2.png'
import SENTuitionImage3 from '../assets/project_images/SEN Tuition 3.png'


export const ProjectData = [
    {
        id: 'apps-portal',
        title: 'SRMakes',
        technologies: 'React, Supabase, PostgreSQL, Tailwind CSS, TanStack Query',
        link: 'https://srmakes.co.uk',
        startMonth: 'NOV 2024',
        endMonth: 'CURRENT',
        bulletPoints: [
            'Built the main SRMakes home for released apps and upcoming products, with project pages, waitlists, feature feedback and the policy links needed by app stores.',
            'Store project page content as structured data in Supabase so the same React components can present different products without duplicating a page for each one.',
            'Use TanStack Query for cached reads and responsive feedback; Supabase functions and row-level security protect waitlist and voting data.',
            'Apply project-specific colours and content within a shared component system, keeping new product pages consistent and quick to maintain.'
        ],
        buttonLinks: [
            {
                title: 'Website',
                link: 'https://srmakes.co.uk'
            }
        ],
        media: [
            {
                type: 'image',
                src: SRMakesImage1,
                link: 'https://srmakes.co.uk',
                description: 'Project Showcase Dashboard'
            },
            {
                type: 'image',
                src: SRMakesImage2,
                link: 'https://srmakes.co.uk/projects/awda',
                description: 'Dynamic Project Hero, Timeline and Problem/Solution Sections'
            },
            {
                type: 'image',
                src: SRMakesImage3,
                link: 'https://srmakes.co.uk/projects/awda',
                description: 'Dynamic Project Potential Features List'
            },
            {
                type: 'image',
                src: SRMakesImage4,
                link: 'https://srmakes.co.uk/projects/awda',
                description: 'Main wait-list for under-development projects to gather user interest'
            },
            {
                type: 'image',
                src: SRMakesImage5,
                link: 'https://srmakes.co.uk/projects/awda',
                description: 'Light Mode Theming with Dynamic Colors'
            },
        ]
    },
    {
        id: 'quick-teams',
        title: 'Quick Teams',
        technologies: 'React Native, Expo, TypeScript, Supabase, Amplitude, Sentry',
        link: 'https://srmakes.co.uk/projects/quick-teams',
        startMonth: 'NOV 2024',
        endMonth: 'CURRENT',
        bulletPoints: [
            'Built and released a cross-platform team generator for iOS and Android. Players can create balanced teams from flexible player and skill inputs.',
            'Use TypeScript and Expo Router to keep the app maintainable across platforms, with Supabase for app data and shared configuration.',
            'Added Sentry error reporting and consent-aware Amplitude analytics to diagnose failures and understand how people use the app.',
            'Manage store builds and compatible over-the-air updates with Expo EAS, including production updates after release.'
        ],
        buttonLinks: [
            {
                title: 'Google Play Store',
                link: 'https://play.google.com/store/apps/details?id=com.SRMakes.QuickTeams&gl=UK'
            },
            {
                title: 'App Store',
                link: 'https://apps.apple.com/us/app/quick-teams-team-generator/id6740728374'
            }
        ],
        media: [
            {
                type: 'image',
                src: QuickTeamsImage1,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: QuickTeamsImage2,
                description: '',
                link: ''
            }

        ]
    },
    {
        id: 'simply-sen',
        title: 'Simply SEN Tuition Website',
        technologies: 'React JS, Vercel, JavaScript, Tailwind CSS',
        link: 'https://www.simplysentuition.co.uk/',
        startMonth: 'NOV 2025',
        endMonth: 'DEC 2025',
        bulletPoints: [
            'Developed a modern, responsive website for Simply SEN Tuition, an educational service specializing in support for students with special educational needs.',
            'Utilized React JS and Tailwind CSS to create a visually appealing and user-friendly interface that effectively communicates the company\'s services and values.',
            'Implemented SEO best practices to enhance online visibility and attract potential clients searching for specialized tuition services.',
            'Deployed the website on Vercel for optimal performance, scalability, and ease of maintenance.',
            'Collaborated closely with the client to ensure the website met their specific requirements and branding guidelines.'
        ],
        buttonLinks: [
            {
                title: 'Visit the Website',
                link: 'https://www.simplysentuition.co.uk/'
            },
        ],
        media: [
            {
                type: 'image',
                src: SENTuitionImage1,
                link: 'https://www.simplysentuition.co.uk/',
                description: 'Simply SEN Tuition Website - Main Page'
            },
            {
                type: 'image',
                src: SENTuitionImage2,
                link: 'https://www.simplysentuition.co.uk/',
                description: 'Simply SEN Tuition Website - Main Page Continued'
            },
            {
                type: 'image',
                src: SENTuitionImage3,
                link: 'https://www.simplysentuition.co.uk/',
                description: 'Simply SEN Tuition Website - Contact Page'
            },
        ]
    },
    {
        id: 'foodii',
        title: 'Foodii',
        position: 'Lead Developer',
        technologies: 'React Native, Expo, React, Supabase',
        link: 'https://www.foodii.co.uk',
        startMonth: 'SEP 2022',
        endMonth: 'FEB 2023',
        logoSrc: foodiLogo,
        bulletPoints: [
            'Built the restaurant companion app and website across React Native, Expo, React and Supabase, owning mobile UI, backend integration, architecture and releases.',
            'Shipped iOS and Android store builds and maintained the shared app and website experience through subsequent updates.',
            'The product is currently paused while other SRMakes products take priority.'
        ],
        buttonLinks: [
            {
                title: 'Google Play Store',
                link: 'https://play.google.com/store/apps/details?id=com.sami246.foodi'
            },
            {
                title: 'Apple Store',
                link: 'https://apps.apple.com/th/app/foodii-restaurant-companion/id6447701868'
            },
            {
                title: 'Website',
                link: 'https://foodii.co.uk'
            },

        ],
        media: [
            {
                type: 'image',
                src: foodigif1,
                link: 'https://foodii.co.uk',
                description: ''
            },
            {
                type: 'image',
                src: foodigif2,
                link: 'https://foodii.co.uk',
                description: ''
            },
            {
                type: 'image',
                src: foodiWebsiteGIF,
                link: 'https://foodii.co.uk',
                description: ''
            },
            {
                type: 'image',
                src: foodiWebsite1,
                link: 'https://foodii.co.uk',
                description: ''
            },
            {
                type: 'image',
                src: foodiCollage1,
                link: 'https://foodii.co.uk',
                description: ''
            },
            {
                type: 'image',
                src: foodiCollage2,
                link: 'https://foodii.co.uk',
                description: ''
            },
        ]
    },
    {
        id: 'awda',
        title: 'Awda',
        technologies: 'React Native, Expo, Supabase, Typescript, Sentry, Amplitude',
        link: null,
        startMonth: 'DEC 2023',
        endMonth: 'CURRENT',
        bulletPoints: [
            'Multi-platform Mobile Application to help Muslim Reverts learn the basics of Islam all in one place',
            'Main Focus of this was front end implementation working with other developers to create the whole application.',
            'Skills such as React-Native-Navigation, Expo, Supabase, Async Storage and many more are displayed within this application',
            'Work in progress screens can be seen below...'
        ],
        media: [
            {
                type: 'image',
                src: AwdaImage1,
                description: '',
                link: ''
            }

        ]

    },
    {
        id: 'royz-rental',
        title: 'Royz Rental',
        technologies: 'React, Vercel',
        link: 'https://www.royzrental.com',
        startMonth: 'MAR 2024',
        endMonth: 'APRIL 2024',
        bulletPoints: [
            'Freelance project to build a website for a car rental business. Everything from the text, design and images handled by myself. Attempt at a sleek, cool design which car enthusiasts will appreciate and be more likely to hire from.',
            'Fully responsive, using modern UI and features such as toasts, blur background, carousels e.t.c.'
        ],
        media: [
            {
                type: 'image',
                src: RoyzImage1,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: RoyzImage2,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: RoyzImage3,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: RoyzImage4,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: RoyzImage5,
                description: '',
                link: ''
            }

        ]
    },
    {
        id: 'learnfinity',
        title: 'Learnfinity',
        technologies: 'React, Vercel',
        link: 'https://www.learnfinity.co.uk',
        startMonth: 'MAY 2024',
        endMonth: 'JUNE 2024',
        bulletPoints: [
            'Freelance project to build a website for a computer science mentoring/boot camp business. The idea was to have a clean, professional design that would attract students and parents alike. While showing all of the main features of the business such as the courses, tutors, testimonials and contact information.',
            'Fully responsive, using modern UI and features such as toasts, blur background, carousels e.t.c.',
            'There have been many changes to the website since the initial build, such as adding a blog, more courses, and a more interactive design.'
        ],
        media: [
            {
                type: 'image',
                src: LearnfinityImage1,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: LearnfinityImage2,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: LearnfinityImage3,
                description: '',
                link: ''
            },
            {
                type: 'image',
                src: LearnfinityImage4,
                description: '',
                link: ''
            },
        ]
    },
    {
        id: 'admin-dashboard',
        title: 'Admin Dashboard',
        technologies: 'React JS, Tailwind CSS',
        link: 'https://sami-dashboard.netlify.app',
        startMonth: 'AUG 2022',
        endMonth: 'SEP 2022',
        bulletPoints: [
            'Built and deployed a React Admin Dashboard App With Theming, Tables, Charts, Calendar, Kanban and many more features using the Syncfusion library as well as Tailwind CSS as the main building blocks.',
            'The project also used React Context API, was completely responsive, and had dark and light themes, using modern UI and folder structure practices.'
        ],
        buttonLinks: [
            {
                title: 'Website',
                link: 'https://sami-dashboard.netlify.app'
            },
        ],
        media: [
            {
                type: 'image',
                src: DashboardImage1,
                link: 'https://sami-dashboard.netlify.app',
                description: ''
            },
            {
                type: 'image',
                src: DashboardImage2,
                link: 'https://sami-dashboard.netlify.app/kanban',
                description: ''
            },
            {
                type: 'image',
                src: DashboardImage3,
                link: 'https://sami-dashboard.netlify.app/area',
                description: ''
            },
            {
                type: 'image',
                src: DashboardImage4,
                link: 'https://sami-dashboard.netlify.app/customers',
                description: ''
            },
        ]
    },
    {
        id: 'family-notice',
        title: 'Family Notice',
        technologies: 'Django, HTML, JQuery',
        link: 'https://github.com/sami246/FamilyNotice',
        startMonth: 'SEPT 2019',
        endMonth: 'JUNE 2020',
        bulletPoints: [
            `My Final Year Project in which I built a responsive web application that was conceived to be a Trello/Facebook for family
            members. It consisted of a multitude of functions such as to-do lists, calendar (linked to Google), geo-location and 5 other
            innovative features that heightened my coding understanding and experience immensely over the long period.`,
            `E.g. Using multiple APIs, such as Google's Maps, utilising unit testing, Django models functionality & deployment via Heroku.`,
            'Definitively not the best in terms of design but we all have to start somewhere 😅 (focus was more on the functionality)'
        ],
        media: [
            // {
            //     type: 'image',
            //     src: FamilyNoticeImage1,
            //     link: 'https://github.com/sami246/FamilyNotice',
            //     description: ''
            // },
            // {
            //     type: 'image',
            //     src: FamilyNoticeImage2,
            //     link: 'https://github.com/sami246/FamilyNotice',
            //     description: ''
            // },
            // {
            //     type: 'image',
            //     src: FamilyNoticeImage3,
            //     link: 'https://github.com/sami246/FamilyNotice',
            //     description: ''
            // },
            // {
            //     type: 'image',
            //     src: FamilyNoticeImage4,
            //     link: 'https://github.com/sami246/FamilyNotice',
            //     description: ''
            // },
            // {
            //     type: 'image',
            //     src: FamilyNoticeImage5,
            //     link: 'https://github.com/sami246/FamilyNotice',
            //     description: ''
            // },
        ]
    },
    {
        id: 'friender',
        title: 'Friender',
        technologies: 'React JS, Java',
        link: null,
        startMonth: 'SEPT 2018',
        endMonth: 'DEC 2018',
        bulletPoints: [
            `As a software engineering project, a group of colleagues and I conceived a web app, from the ground up, including all steps needed
            for a successful real-world environment such as Domain analysis, Design report etc. We used Java for the back end and React for
            the front end.`,
            `The project increased my ability to work in a pressured, time-constrained team, sharpening skills such as supporting
            and organising fellow team members while aiming to deliver the best end product.`
        ],
        media: [

        ]
    },
    {
        id: 'auction-website',
        title: 'Auction Website (eBay Clone)',
        technologies: 'Django, HTML, Ajax, CSS, Postgresql',
        link: null,
        startMonth: 'SEPT 2019',
        endMonth: 'DEC 2019',
        bulletPoints: [
            `Implementing Django framework, Ajax and HTML, using Bootstrap for the main UI. The site included login authentication, bid, search,
            notification, email and bid tracking functions, to name a few. It is fully responsive and deployed using Openshift.`
        ],
        media: [

        ]
    },
    {
        id: 'recipe-finder',
        title: 'Recipe Finder Website',
        technologies: 'React JS, Splide, CSS',
        link: 'https://github.com/sami246/recipe_app',
        startMonth: 'AUG 2022',
        endMonth: 'AUG 2022',
        bulletPoints: [
            `Simple project using with the key features being: Gathering data from API, using react-router-dom for routing, having a fully functional
            search bar which uses API query to match recipe to input, and using Splide for seamless movement of cards and modern UI`
        ],
        media: [
            {
                type: 'image',
                src: RecipeFinderImage1,
                link: 'https://github.com/sami246/recipe_app'
            },
            {
                type: 'image',
                src: RecipeFinderImage2,
                link: 'https://github.com/sami246/recipe_app'
            },
            {
                type: 'image',
                src: RecipeFinderImage3,
                link: 'https://github.com/sami246/recipe_app'
            }
        ]
    },
    {
        id: 'travel-advisor',
        title: 'Travel Advisor Website',
        technologies: 'React JS, Material UI',
        link: 'https://sami-travel-advisor.netlify.app',
        startMonth: 'SEP 2022',
        endMonth: 'SEP 2022',
        bulletPoints: [
            `Using React and Google API I created a website which takes the location of the user, or any search input and then displays potential
            hotels, restaurants or attractions that the user can visit. The UI is done mainly with Material UI, using React best practices, allowing
            for filters of rating, clicking on the map directs you to further info on the location and many more intuitive features. I used this project
            to become familiar with using Maps API for a project currently being worked on for commercial development.`
        ],
        media: [
            {
                type: 'image',
                src: TravelAdvisorImage1
            }
        ]
    },
    // {
    //     id: 'demon-slayer-unity-game',
    //     title: 'Demon Slayer Unity Game',
    //     technologies: 'Unity, C#',
    //     link: 'https://docs.google.com/document/d/1QOmrPP6H8uLkEXbx791s3Ve1nKxMR7-HCJIHb9vqjhQ/edit?usp=sharing',
    //     startMonth: 'JAN 2021',
    //     endMonth: 'JUNE 2021',
    //     bulletPoints: [
    //         'Using Unity & C# I created a game based on the anime demon slayer. It included various game-making techniques such as scores, health bar, attacking, animations, sound design, level design, AI, enemies, UI and much more.'
    //     ],
    //     media: [
    //         {
    //             type: 'video',
    //             src: 'https://www.youtube.com/embed/HNdUZPEna1Q?si=0c98yTXOVIHkDSFi'
    //         },
    //     ]
    // },
    // {
    //     title: '',
    //     technologies: '',
    //     link: null,
    //     startMonth: '',
    //     endMonth: '',
    //     bulletPoints: [
    //         ''
    //     ]
    // },
]
